import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_ITEMTAP_BACKEND_URL
});

// Request interceptor to add authentication token
api.interceptors.request.use(config => {
  const authToken = localStorage.getItem('token');
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

// Response interceptor to handle unauthorized responses
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Clear local storage and redirect to login if unauthorized
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('tokenExpiry');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const requestItem = async (itemId) => {
  const response = await axios.post('/api/request-item', {
    item_id: itemId
  });
  return response.data;
};

export default api; 